import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SysTextService } from '@core/services/sys-text.service';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { closeDialogOnEscape } from '@shared/helpers';

@Component({
    selector: 'app-idle-alert',
    templateUrl: './idle-alert.component.html',
    styleUrls: ['./idle-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IdleAlertComponent implements OnInit {
  static readonly componentName = 'IdleAlertComponent';

  public position = position;
  public onDragEnded = onDragEnded;

  private readonly template = 'idleAlertDialog';

  sysText$: Observable<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { timeRemaining: number },
    private textService: SysTextService,
    private idleAlertDialogRef: MatDialogRef<IdleAlertComponent>
  ) { }

  ngOnInit() {
    closeDialogOnEscape(this.idleAlertDialogRef, null, () => this.idleAlertDialogRef.close(true));

    this.sysText$ = this.textService.getSysText(this.template).pipe(
      catchError((err) => {
        // keeps them logged in
        // pass false to close method to log out on sysText error
        this.idleAlertDialogRef.close(true);
        return of(err);
      })
    );
  }
}
